import { useSelector } from 'react-redux';

import { getBreadcrumbDataForCategory } from './productsModule';

export default function useCategoryBreadcrumbs(categoryId) {
  return useSelector((state) =>
    getBreadcrumbDataForCategory(state, categoryId)
  );
}
